import styled from "styled-components"

export const StyledUserPanelEmployees = styled.section`
    width: 100%;
    height: 100%;
    
    @media only screen and (max-width: 926px){
        margin-top: 20px;
    }
`